import {
  Directive,
  ElementRef,
  Renderer2,
  HostListener,
  AfterViewInit,
  OnDestroy,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appDisableRightClick]',
  standalone: true
})
export class DisableRightClickDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit() {
      // Always set attributes (works during prerender on server too)
      this.ensureLazyLoading();
      this.ensureAltAttribute();

      // Only attach observers and read computed styles in browser
      if (isPlatformBrowser(this.platformId)) {
        this.observeImageSrc();
        this.updateParentBackground();
      }
  }

  private observeImageSrc() {
    const img = this.el.nativeElement as HTMLImageElement;

    if (img) {
      if (isPlatformBrowser(this.platformId)) {
        this.observer = new MutationObserver(() => {
          this.updateParentBackground();
          this.ensureLazyLoading();
          this.ensureAltAttribute();
        });

        this.observer.observe(img, {
          attributes: true,
          attributeFilter: ['src', 'loading']
        });
      }
    }
  }

  private updateParentBackground() {
    const img = this.el.nativeElement as HTMLImageElement;
    const parent = img?.parentElement;

    if (parent && img && isPlatformBrowser(this.platformId)) {
      const bgImage = getComputedStyle(parent)?.backgroundImage;
      const hasBackgroundImage = bgImage && bgImage.startsWith('url(') && !bgImage.includes('url("")') && !bgImage.includes('url()');
    
      const hasImageClass = parent.classList?.contains('has-image');
      const isValidImage = img.complete && img.naturalWidth > 0 && hasBackgroundImage;
    
      if (isValidImage && !hasImageClass) {
        this.renderer.addClass(parent, 'has-image');
      } else if (isValidImage && hasImageClass) {
        this.renderer.removeClass(parent, 'has-image');
      }

    }    
  }

  private ensureLazyLoading() {
    const img = this.el.nativeElement as HTMLImageElement;
    if (!img) return;
    const loadingAttr = img.getAttribute('loading');
    if (!loadingAttr || loadingAttr.trim() === '') {
      this.renderer.setAttribute(img, 'loading', 'lazy');
    }
  }

  private ensureAltAttribute() {
    const img = this.el.nativeElement as HTMLImageElement;
    if (!img) return;
    const hasAlt = img.hasAttribute('alt');
    if (!hasAlt) {
      // Set a default alt value when missing
      this.renderer.setAttribute(img, 'alt', 'TopFan');
    }
  }

  @HostListener('load')
  onImageLoad() {
    this.updateParentBackground();
  }

  @HostListener('error')
  onImageError() {
    this.updateParentBackground();
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
    return false;
  }

  @HostListener('dragstart', ['$event'])
  onDragStart(event: DragEvent) {
    event.preventDefault();
    return false;
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    return false;
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
